import { Conversation, Message } from '@the-real-insight/tri-model';
import { useCallback, useEffect, useRef, useState } from 'react';
import { ChatConversation } from './ChatConversation';
import { authenticationAtom, conversationAtom } from '../State';
import { useAtom } from 'jotai';
import { MessageType } from '@the-real-insight/tri-model';
import { FontIcon } from '@fluentui/react/lib/Icon';
import { TextField } from '@fluentui/react/lib/TextField';
import { Link } from '@fluentui/react/lib/Link';
import { useTranslation } from 'react-i18next';
import { userAPI } from '../UserAPI';
import { useSpeech } from '../Speech';
import { IconButton } from '@fluentui/react/lib/Button';
import i18next from 'i18next';
import { mergeStyles } from '@fluentui/react/lib/Styling';
import { MessageBarType } from '@fluentui/react/lib/MessageBar';
import { MessageBar } from '@fluentui/react/lib/MessageBar';
import { formatNumber1 } from '../utilities/format';

const userContext = { firstName: 'Marc', lastName: 'Gille-Sepehri', email: 'marc@thing-it.com', mesh: '65093dfececde3b84a486809' }
const iconClass = {
    fontSize: 30,
    height: 30,
    width: 30,
};
const suggestionIconStyles = [
    mergeStyles({ color: 'darkblue', ...iconClass }),
    mergeStyles({ color: 'darkred', ...iconClass }),
    mergeStyles({ color: 'darkgreen', ...iconClass }),
    mergeStyles({ color: 'purple', ...iconClass })];

interface Properties {
    conversation: Conversation;
    showSuggestions: boolean;
    showLogo: boolean;
    height?: string;
    resourceSelected?: (resource: any) => void;
    newConversation?: () => void;
}

export const ChatExchange = (properties: Properties) => {
    const { t } = useTranslation();
    const [locale] = useState(i18next.resolvedLanguage);
    const [authentication] = useAtom(authenticationAtom) as any;
    const [conversation, setConversation] = useAtom(conversationAtom) as any;
    const [pendingRequest, setPendingRequest] = useState(false);
    const textField = useRef<any>(null);
    const [inputValue, setInputValue] = useState() as any;
    const [inputFocussed, setInputFocussed] = useState(false);
    const [id, setId] = useState(null) as any;
    const [requestIndex, setRequestIndex] = useState(0);
    const [requests, setRequests] = useState([]) as any;
    const [skillAgentResponse, setSkillAgentResponse] = useState(null);
    const [transcribing, setTranscribing] = useState(false);
    const [agent, setAgent] = useState(null) as any;
    const [resetSuggestionsTimer, setResetSuggestionsTimer] = useState(true);
    const [chatUpdate, setChatUpdate] = useState(Date.now());
    const [skills, setSkills] = useState([]);
    const [suggestions, setSuggestions] = useState([]) as any;
    const [showSuggestions, setShowSuggestions] = useState(false);

    // TODO What is this for?
    const handleFeedback = (messageIndex: number, isPositive: boolean) => {
        console.log(`Feedback for message ${messageIndex}: ${isPositive ? 'positive' : 'negative'}`);
    };

    const capitalizeFirstLetter = (value: string) => {
        return value.charAt(0).toUpperCase() + value.slice(1);
    }

    const recordRequest = useCallback((request: string) => {
        if (request) {
            setRequests([...requests, request]);
            setRequestIndex(requests.length);
        }
    }, [requests])

    const parseMessageChunk = (chunk: string, parsingState: any) => {
        let { newConversation, payloadString } = parsingState;
        const currentMessage = newConversation.messages[newConversation.messages.length - 1];

        while (chunk.length > 0) {
            if (!!payloadString) {
                const payloadEnd = chunk.indexOf('```');

                if (payloadEnd >= 0) {
                    console.log('===> Complete parsing payload');

                    payloadString += chunk.substring(0, payloadEnd);

                    let payload: any = {};

                    try {
                        payload = JSON.parse(payloadString);
                    } catch (error) {
                        console.error(error);
                    }

                    if (payload.endOfMessage) {
                        newConversation.messages.push(new Message(MessageType.botMessage, '', false, []));
                    } else if (payload.resources) {
                        currentMessage.resources = payload.resources;

                        setConversation(newConversation.clone());
                        setChatUpdate(Date.now());
                    }

                    payloadString = null;
                    chunk = chunk.substring(payloadEnd + 3);
                } else {
                    payloadString += chunk;
                    chunk = '';
                }
            } else if (chunk.indexOf('```payload') >= 0) {
                const payloadStart = chunk.indexOf('```payload');
                currentMessage.content += chunk.substring(0, payloadStart);

                setConversation(newConversation.clone());
                setChatUpdate(Date.now());

                chunk = chunk.substring(payloadStart + 11);

                const payloadEnd = chunk.indexOf('```');

                if (payloadEnd >= 0) {
                    const payloadChunk = chunk.substring(0, payloadEnd);

                    let payload: any = {};

                    try {
                        payload = JSON.parse(payloadChunk);
                        console.log('Payload >>>', payload);
                    } catch (error) {
                        console.error(error);
                    }

                    if (payload.endOfMessage) {
                        console.log('===> End of message');

                        newConversation.messages.push(new Message(MessageType.botMessage, '', false, []));
                    } else if (payload.resources) {
                        currentMessage.resources = payload.resources;

                        console.log('===> Resources >>>', payload.resources);

                        setConversation(newConversation.clone());
                        setChatUpdate(Date.now());

                        const newSkillAgentResponse = payload.output ? payload.output : payload;
                        setSkillAgentResponse(newSkillAgentResponse);
                    }

                    payloadString = null;

                    chunk = chunk.substring(payloadEnd + 3);
                } else {
                    payloadString = chunk;
                    chunk = '';
                }
            } else {
                currentMessage.content += chunk;

                setConversation(newConversation.clone());
                setChatUpdate(Date.now());

                chunk = '';
                payloadString = null;
            }
        }

        return { newConversation, payloadString };
    }

    const submitInput = useCallback(async (input: string) => {
        if (!input || input.trim().length === 0) {
            return;
        }

        input = capitalizeFirstLetter(input);

        const allowsConfirmation = conversation.length > 0 && (conversation[conversation.length - 1].type === 'botSuggestion' ||
            conversation[conversation.length - 1].confirmation);
        let newConversation = conversation.clone();

        newConversation.messages.push(new Message(MessageType.userMessage, input, false, []));

        setConversation(newConversation);
        setInputValue(null);
        setShowSuggestions(false);

        if (allowsConfirmation) {
            if (input.trim().toLowerCase() === 'yes' && conversation.messages[conversation.messages.length - 1].type === 'botSuggestion') {
                input = conversation.messages[conversation.messages.length - 1].prompt;
            } else if (input.trim().toLowerCase() === 'no') {
                textField.current.focus();

                return;
            }
        } else {
            recordRequest(input);
        }

        setPendingRequest(true);

        try {
            // const payload = await userAPI.submitRequest(id, agent, selectedProfile.key, input,
            //     { location: { spaceName: selectedItem.key }, user: userContext, locale });

            // console.log('Payload >>>', payload);

            // const newSkillAgentResponse = payload.output ? payload.output : payload;

            // setAgent(payload.agent);
            // setSkillAgentResponse(newSkillAgentResponse);

            const responseStream = await userAPI.streamPromptResponse(conversation._id, agent, 'Profile1', input,
                { location: { spaceName: 'Space1' }, user: userContext, locale }) as any;

            // if (newSkillAgentResponse.skill && newSkillAgentResponse.followUp === 'clientAction') {
            //     if (newSkillAgentResponse.resources && newSkillAgentResponse.resources[0] && newSkillAgentResponse.resources[0].path) {
            //         navigate(newSkillAgentResponse.resources[0].path);
            //     } else {
            //         // TODO Should generate error text
            //         toggleHideDialog();
            //     }
            // } else {        

            const decoderStream = new TextDecoderStream("utf-8");

            newConversation.messages.push(new Message(MessageType.botMessage, '', false, []));

            let parsingState = {
                newConversation: newConversation.clone(),
                payloadString: null as any,
            };

            const writer = new WritableStream({
                write(chunk) {
                    console.log('### Chunk ###');

                    parsingState = parseMessageChunk(chunk, parsingState);
                },
                abort(reason) {
                    console.log('Stream aborted:', reason);
                    setPendingRequest(false);
                },
                close() {
                    console.log('Stream closed');
                    setPendingRequest(false);
                }
            });

            responseStream.body
                .pipeThrough(decoderStream)
                .pipeTo(writer);

            setShowSuggestions(false);
        } catch (error) {
            console.error(error);

            newConversation.messages.push(new Message(MessageType.botMessage, 'Ich scheine Kommunikationsprobleme zu haben.', false, []));

            setConversation(newConversation.clone());

            setShowSuggestions(false);
            setPendingRequest(false);

            return 'Ich scheine Kommunikationsprobleme zu haben.';
        }
    }, [agent, id, conversation, recordRequest]);

    const submitSuggestion = (request: any) => {
        setInputValue(request);
        setShowSuggestions(false);
        submitInput(request);
    }

    const onKeyDown = (event: any) => {
        if (event.key === 'Enter') {
            submitInput(inputValue);
        } else if (event.key === 'ArrowUp') {
            const newRequestIndex = Math.max(requestIndex - 1, 0);

            setRequestIndex(newRequestIndex);
            setInputValue(requests[newRequestIndex]);
            event.preventDefault();

            return false;
        } else if (event.key === 'ArrowDown') {
            const newRequestIndex = Math.min(requestIndex + 1, requests.length - 1);

            setRequestIndex(newRequestIndex);
            setInputValue(requests[newRequestIndex]);
            event.preventDefault();

            return false;
        }
    };

    const selectSuggestions = (skills: any) => {
        const shuffledSkills = skills.sort(() => 0.5 - Math.random());
        const shuffledIconStyles = suggestionIconStyles.sort(() => 0.5 - Math.random());

        setSuggestions(shuffledSkills.slice(0, 4).map((skill: any, index: number) => {
            return { ...skill, iconStyles: shuffledIconStyles[index], index: Date.now() % skill.examples.length }
        }));
    };

    useSpeech((text: string, final: any) => {
        setInputValue(text);

        if (final) {
            setTranscribing(false);
        }
    }, transcribing);


    useEffect(() => {
        const f = async () => {
            const newSkills = await userAPI.getSkills();

            console.log('New skills >>>', newSkills);

            setSkills(newSkills);

            // let conversations = await userAPI.getConversations(authentication.customer);

            // console.log('Conversations >>>', conversations);

            // let conversation = null;

            // // TODO Canned call?
            // if (conversations.length === 0) {
            //     conversation = await userAPI.createConversation(authentication.customer);

            //     selectSuggestions(newSkills);
            // } else {
            //     conversation = conversations[0];
            // }

            // setConversation(conversation);
        };

        f();
    }, []);

    useEffect(() => {
        setConversation(properties.conversation);
        textField.current.focus();
    }, [properties.conversation]);

    useEffect(() => {
        if (!resetSuggestionsTimer) {
            return;
        }

        let interval: any;

        if (skills.length > 0) {
            interval = setInterval(() => {
                selectSuggestions(skills);
            }, 10000);
        }

        return () => clearInterval(interval);
    }, [skills, resetSuggestionsTimer]);

    // TODO Cleanup!

    // useEffect(() => {
    //     scrollToBottom();
    //     // const socket = io(`${baseUrl}`);

    //     // socket.on("connect", () => {
    //     //     setId(socket.id);

    //     //     socket.on("suggestion", (suggestion) => {
    //     //         setConversation([...conversation, {
    //     //             type: 'botSuggestion',
    //     //             content: suggestion.message,
    //     //             prompt: suggestion.prompt,
    //     //         }]);

    //     //         textField.current.focus();
    //     //     });

    //     //     socket.on("message", (message) => {
    //     //         setConversation([...conversation, {
    //     //             type: 'botMessage',
    //     //             content: message
    //     //         }]);
    //     //     });
    //     // });
    // }, [chatUpdate]);

    useEffect(() => {
        if (!textField.current) {
            return;
        }

        if (!pendingRequest) {
            textField.current.focus();
        } else {
            textField.current.blur();
        }
    }, [pendingRequest]);

    // useEffect(() => {
    //     speechController.current.recognizingCallback = (text) => {
    //         setInputValue(text);
    //     }
    //     speechController.current.recognizedCallback = submitInput;
    //     speechController.current.stateChangeCallback = (state) => {
    //         setSpeechControllerState(state);
    //     }
    //     speechController.current.listen();
    // }, [speechController, submitInput]);

    return (
        <div className='paddingLeft200px paddingRight200px displayFlex flexDirectionColumn' style={{ minHeight: `${properties.height || '0px'}`, maxHeight: properties.height ? `${properties.height}` : '100%' }}>
            <div className='flexGrow1 paddingM overflowYScroll'>
                <ChatConversation
                    conversation={conversation}
                    pendingRequest={pendingRequest}
                    submitInput={submitInput}
                    onFeedback={handleFeedback}
                    resourceSelected={properties.resourceSelected}
                />
            </div>
            {conversation && (conversation.messages.length === 0 || showSuggestions) ?
                <>
                    {conversation.messages.length === 0
                        ?
                        (properties.showLogo ? <div className='logo'>
                            {(() => {
                                switch (authentication?.customer) {
                                    case 'A8Z1-ZQGN-YKN3': // BOSCH
                                        return <img className="botBrandingImage" src="/logos/bosch/schlaubi.jpeg" alt="logo" />;
                                    case 'C2Z2-QQGN-YKW6': // gefma
                                        return <img className="botBrandingImage" src="/logos/gefma/logo.png" alt="logo" />;
                                    case '4714': // Pastor
                                        return <img className="botBrandingImage" src="/logos/pastor/schlaubi.jpeg" alt="logo" />;
                                    default:
                                        return <img className="logoImage" src="/logo.png" alt="logo" />;
                                }
                            })()}
                        </div> : <></>)
                        :
                        <div className="paddingM displayFlex justifyContentEnd gapsM ">
                            <IconButton iconProps={{ iconName: 'Refresh' }} title="Refresh" aria-label="Refresh" onClick={() => {
                                if (skills) { selectSuggestions(skills) }
                                setResetSuggestionsTimer(true);
                            }} />
                            <IconButton iconProps={{ iconName: 'Cancel' }} title="Close" aria-label="Close" onClick={() => setShowSuggestions(false)} />
                        </div>
                    }
                    {properties.showSuggestions && suggestions && suggestions.length > 0 && !(inputValue && inputValue.trim().length > 0) &&
                        <>
                            <div className="suggestions">
                                <div key={suggestions[0].id} className='suggestion rollOut' onClick={() => submitSuggestion(suggestions[0].examples[suggestions[0].index])}>
                                    <FontIcon iconName={suggestions[0].icon} className={suggestions[0].iconStyles} aria-label="send" />
                                    <div className='request'>{suggestions[0].examples[suggestions[0].index]}</div>
                                </div>
                                <div key={suggestions[1].id} className='suggestion rollOut' onClick={() => submitSuggestion(suggestions[1].examples[suggestions[1].index])}>
                                    <FontIcon iconName={suggestions[1].icon} className={suggestions[1].iconStyles} aria-label="send" />
                                    <div className='request'>{suggestions[1].examples[suggestions[1].index]}</div>
                                </div>
                                <div key={suggestions[2].id} className='suggestion rollOut' onClick={() => submitSuggestion(suggestions[2].examples[suggestions[2].index])}>
                                    <FontIcon iconName={suggestions[2].icon} className={suggestions[2].iconStyles} aria-label="send" />
                                    <div className='request'>{suggestions[2].examples[suggestions[2].index]}</div>
                                </div>
                            </div>
                        </>
                    }
                </>
                :
                <></>
            }
            {properties.showSuggestions && (
                <div className="displayFlex justifyContentEnd">
                    {!showSuggestions && (
                        <div className="hoverHand marginTopS marginBottomS paddingM" onClick={() => setShowSuggestions(true)}>
                            {t('chatBotPage.needMoreIdeas')}
                        </div>
                    )}
                </div>
            )}
            <div className="inputContainer">
                <div className="height20">
                    {conversation && conversation.memorySize() > 10000000 &&
                        <MessageBar delayedRender={false} messageBarType={MessageBarType.error}>
                            <span className="textS">Der Speicherbedarf der Konversation ist {formatNumber1(conversation.memorySize() / 1000000)} MB
                                <a className="marginLeftXS hoverHand" onClick={() => properties.newConversation?.()}>
                                    Neue Konversation
                                </a>
                            </span>
                        </MessageBar>
                    }
                </div>
                <div className="marginTopM displayFlex">
                    <TextField
                        className="flexGrow1"
                        componentRef={textField}
                        styles={{
                            fieldGroup: [
                                { width: '100%' },
                            ]
                        }}
                        placeholder={pendingRequest ? '' : (requests && requests.length > 0 ? `${t('chatBotPage.canIHelpWithAnythingElse')} ${requests.length > 0 ? '(⭡⭣' + t('chatBotPage.forHistory') + ')' : ''}` : `${t('chatBotPage.canIHelp')}`)}
                        value={inputValue}
                        disabled={pendingRequest}
                        onFocus={() => setInputFocussed(true)}
                        onBlur={() => setInputFocussed(false)}
                        onChange={(event, value) => setInputValue(value || '')}
                        onKeyDown={onKeyDown}
                    />
                    <div className='marginLeftS displayFlex gapM'>
                        {inputValue && inputValue.trim().length > 0 ? (
                            <div onClick={() => submitInput(inputValue)}>
                                <FontIcon iconName={'Send'} className="hoverHand textXL colorPrimary" aria-label="Send" />
                            </div>
                        ) : transcribing ? (
                            <div onClick={() => setTranscribing(false)}>
                                <FontIcon iconName={'CircleStopSolid'} className="hoverHand textXL colorRed pulsing" aria-label="Stop Recording" />
                            </div>
                        ) : (
                            <div onClick={() => setTranscribing(true)}>
                                <FontIcon iconName={'Microphone'} className="hoverHand textXL colorPrimary" aria-label="Start Recording" />
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}; 